// extracted by mini-css-extract-plugin
module.exports = {"example":"BookingPanelExample_example__3j3HQ"};